// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2faAf","footer":"ModalCreateQualiphyProcedure_footer__16-gW","additionData":"ModalCreateQualiphyProcedure_additionData__3fE1z"};